// ================================================================================
// script.js
// 案件用のスクリプトファイル
// ================================================================================

$(function(){

	// device check
	// --------------------------------------------------------------- //
	var device;

	function check_device() {
		var breakpoint_m = 1215;
		var breakpoint_s = 960;
		var $window = $(window);
		var window_width = parseInt($window.width());
		if (window_width <= breakpoint_m && window_width > breakpoint_s) {
			device = 'tab';
		} else if (window_width <= breakpoint_s) {
			device = 'sp';
		} else {
			device = 'pc';
		}
	}
	check_device();
	// console.log(device);


	// init
	// --------------------------------------------------------------- //
	var $window = $(window);
	var $body = $('body');

	// ヘッダーナビゲーション
	// --------------------------------------------------------------- //
	$('.js-header-nav').click(function() {
		$(this).toggleClass('header-nav__button--close');
		$('.js-header-menu').toggleClass('header-menu--active');

		if ( $('.js-header-menu-body').hasClass('header-menu__body--active') ) {
			$('.js-header-menu-body').removeClass('header-menu__body--active');
		} else {
			setTimeout(function() {
				$('.js-header-menu-body').addClass('header-menu__body--active');
			}, 300);
		}
	} );



	// ヘッダースクロール
	// --------------------------------------------------------------- //
	var header_small_pos = 240;

	$window.on('load scroll resize', function () {
		var scl = $window.scrollTop();
		if( scl >= header_small_pos ){
			$('.js-header').addClass('header--small');
			$('.js-header-floating-banner').addClass('header-floating-banner--small');
			$('#js-member-anchor').addClass('is-small');
		}else{
			$('.js-header').removeClass('header--small');
			$('.js-header-floating-banner').removeClass('header-floating-banner--small');
			$('#js-member-anchor').removeClass('is-small');
		}
	} );



	// ページトップ
	// --------------------------------------------------------------- //
	$('.js-page-top').click(function(){
		$('body, html').animate({
			scrollTop: 0
		}, 400);

		return false;
	});



	// side accordion
	// --------------------------------------------------------------- //

	$('.js-side-filter-accordion').click(function() {

		$(this).toggleClass('is-open');
		$(this).closest('.side-filter').find('.js-side-filter-contents').slideToggle();

	} );





	// member archive
	// --------------------------------------------------------------- //

	$('#js-member-filter-accordion').click(function() {

		$(this).toggleClass('is-open');
		$('#js-member-filter-contents').slideToggle();

	} );

	$('.js-member-filter-toggle').click(function() {
		var $target = $(this).data('target');

		if ( $(this).hasClass('is-open') ) {
			$('.member-filter-item.' + $target).slideToggle();
			$(this).removeClass('is-open');
		} else {
			$('.member-filter-item').each(function() {
				$(this).hide();
			} );
			$('.js-member-filter-toggle').each(function() {
				$(this).removeClass('is-open');
			} );
			$('.member-filter-item.' + $target).slideToggle();
			$(this).addClass('is-open');

		}



	} );



	// practice scroll spy
	// --------------------------------------------------------------- //

	var practice_active = -1;
	var practice_gap = 120 // おおよそのヘッダーと上パディングの分

	if ( $('#js-practice-anchor').length ) {
		practice_scroll_spy();
	}

	function practice_scroll_spy() {
		var practice_array = new Array();

		$('.c-practice-stack').each(function(i) {
			practice_array[i] = $(this).offset().top - practice_gap;
		});

		console.log(practice_array);

		$window.on('load scroll resize', function(){
			for (var i = practice_array.length - 1 ; i >= 0; i--) {
				if ($window.scrollTop() > practice_array[i] - 0.1) {
					change_practice_item(i);
					break;
				}
			}
		});
	}

	change_practice_item(0); // 第一要素に active 付与

	function change_practice_item(block) {
		if ( block != practice_active ) {
			practice_active = block;
			var item_current = block; // 第二要素以降

			$('#js-practice-anchor .c-practice-anchor-list__link').removeClass('is-active');

			$('#js-practice-anchor .c-practice-anchor-list__link.is-num-' + item_current).addClass('is-active');
		}
	}



	// member more
	// --------------------------------------------------------------- //
	var $more_button = $('.js-more');
	var $more_item = $('.js-more-item');

	$more_button.click(function() {
		var $parent = $(this).closest('.wp-member-item-more').prev();
		$parent.children('.js-more-item:gt(4)').fadeIn();
		$(this).remove();
		member_scroll_spy();
	} );


	// member scroll spy
	// --------------------------------------------------------------- //

	var active = -1;
	var gap = 120 // おおよそのヘッダーと上パディングの分

	if ( $('#js-member-anchor').length ) {
		member_scroll_spy();
	}

	function member_scroll_spy() {
		var member_array = new Array();

		member_array.push(0);

		$('.wp-member-item').each(function(i) {
			var j = i + 1;
			member_array[j] = $(this).offset().top - gap;
		});

		$window.on('load scroll resize', function(){
			for (var i = member_array.length - 1 ; i >= 0; i--) {
				if ($window.scrollTop() > member_array[i] - 0.1) {
					change_item(i);
					break;
				}
			}

			var scroll_height = $(document).height();
			var scroll_pos = $(window).height() + $(window).scrollTop();
			var foot_height = $('.cta-area').innerHeight() + $('.footer').innerHeight() + 96;

			if (scroll_height - scroll_pos <= foot_height) {
				$('#js-member-anchor').addClass('is-hidden');
			} else {
				$('#js-member-anchor').removeClass('is-hidden');
			}
		});
	}

	change_item(0); // 第一要素に .active 付与

	function change_item(block) {
		if ( block != active ) {
			active = block;
			var item_current = block; // 第二要素以降

			$('#js-member-anchor .c-member-menu__link').removeClass('is-active');

			$('#js-member-anchor .c-member-menu__link.is-num-' + item_current).addClass('is-active');
		}
	}

	// member pdf button
	// --------------------------------------------------------------- //

	$('#js-print-button').click(function() {
		var $header = $('.header'),
		$floating_banner = $('.js-header-floating-banner'),
		$member_anchor = $('#js-member-anchor'),
		$cta_area = $('.cta-area'),
		$footer = $('footer');
		$header.hide();
		$floating_banner.hide();
		$member_anchor.hide();
		$cta_area.hide();
		$footer.hide();

		window.print();

		$header.show();
		$floating_banner.show();
		$member_anchor.show();
		$cta_area.show();
		$footer.show();

		member_scroll_spy();
	} );



	// form バリデーション
	// --------------------------------------------------------------- //
	if ( $('.js-form').length ) {
		// check_func();
	}

	function check_func() {
		var check = true;
		$('.js-require').each(function() {
			if ( $(this).val() == '' ) {
				check = false;
			}
		});

		if ( !$('.js-require-email').val().match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/) ) {
			check = false;
		}

		if ( check === true ) {
			$('.js-form-submit').prop('disabled', false);
		} else {
			$('.js-form-submit').prop('disabled', true);
		}

		// select style
//		$('select').each(function() {
//			if ( $(this).val() == '' ) {
//				$(this).css('color', '#ccc');
//			} else {
//				$(this).css('color', '#000');
//			}
//		} );

	}

	$(document).on('keydown keyup keypress change', '.js-require', function() {
		// check_func();
	});

	// uploads validation
	$('input[type=file]').change(function() {
		var file = $(this).prop('files')[0];

		if ( file.size > 5000000 ) {
			$(this).closest('div').append('<span class="c-form-attention">ファイルサイズの上限は5MBです。</span>');
			$('.js-form-submit').prop('disabled', true);
		} else {
			$(this).closest('div').find('.c-form-attention').remove();
			// check_func();
		}
	});


	// ファイルサイズの単位
	// --------------------------------------------------------------- //
	function getFiseSize(file_size) {
		var str;

		// 単位
		var unit = ['byte', 'KB', 'MB', 'GB', 'TB'];

		for (var i = 0; i < unit.length; i++) {
			if (file_size < 1024 || i == unit.length - 1) {
				if (i == 0) {
					// カンマ付与
					var integer = file_size.toString().replace(/([0-9]{1,3})(?=(?:[0-9]{3})+$)/g, '$1,');
					str = integer +  unit[ i ];
				} else {
				// 小数点第2位は切り捨て
				file_size = Math.floor(file_size * 100) / 100;
				// 整数と小数に分割
				var num = file_size.toString().split('.');
				// カンマ付与
				var integer = num[0].replace(/([0-9]{1,3})(?=(?:[0-9]{3})+$)/g, '$1,');
				if (num[1]) {
					file_size = integer + '.' + num[1];
				}
				str = file_size +  unit[ i ];
			}
			break;
		}
		file_size = file_size / 1024;
	  }

		return str;
	}


	// スムーズスクロール
	// --------------------------------------------------------------- //
	var smooth_scroll = function () {
		var $header = $('.js-header');
		var header_height;
		if (device == 'sp') {
			header_height = 56;
		} else {
			//header_height = 53;
			header_height = 88;
		}

		if ( $('body').hasClass('single-post') ) {
			header_height = 30;
		}


		var urlHash = location.hash;
		var animeSpeed = 500;

		if (urlHash) {
			$('html, body').stop().scrollTop(0);
			setTimeout(function () {
				var target = $(urlHash);
				var position = target.offset().top - header_height;
				$('html, body').stop().animate({ scrollTop: position }, animeSpeed);
			}, 100);
		}

		var $btn = $('a[href*="#"]');
		var $target = $('.js-navigation');
		var class_name = 'is-open';

		$btn.click(function () {
			var speed = 500;
			var href = $(this).attr("href");
			href = href.split("#")[1];
			href = "#" + href;
			var target = $(href == "#" || href == "" ? 'html' : href);
			var position = target.offset().top - header_height;

			// ハンバーガーメニューがアクティブのとき
			if ($target.hasClass(class_name)) {
				$target.removeClass(class_name);
				$body.attr({
					style: ''
				});
				$(window).scrollTop(current_scrollYsm);
				position = target.offset().top - header_height;
				$("html, body").animate({ scrollTop: position }, speed, "swing");
			} else {
				$("html, body").animate({ scrollTop: position }, speed, "swing");
			}
			return false;
		});
	}
	smooth_scroll();


	// accordion
	// --------------------------------------------------------------- //
	$(function () {
		var $parent = $('.js-accordion');
		var $btn = $('.js-accordion-btn');
		var $target = $('.js-accordion-trgt');

		// on click
		$btn.each(function () {
			var class_name = 'is-accordion-open';
			$(this).click(function () {
				if (!$(this).parent($parent).hasClass(class_name)) {
					$(this).parent($parent).addClass(class_name);
					$(this).next($target).stop().slideDown(200);
				} else {
					$(this).parent($parent).removeClass(class_name);
					$(this).next($target).stop().slideUp(200);
				}
			});
		});
	});


	// swiper
	// --------------------------------------------------------------- //
	// LPO - clients-story
	$(function () {
		var hero_slider = new Swiper('.js-clients-story-slider', {
			loop: false,
			speed: 800,
			slidesPerView: 3,
			spaceBetween: 36,
			direction: 'horizontal',
			effect: 'slide',

			navigation: {
				prevEl: '.js-clients-story-navi-prev',
				nextEl: '.js-clients-story-navi-next',
			},

			breakpoints: {
				768: {
					slidesPerView: 1,
					// spaceBetween: 30,
					// centeredSlides : true
				},
			}
		});
	});


	// form rafio check
	// --------------------------------------------------------------- //
	$(function () {
		var $btn_doc = $('.js-checked-document, .js-checked-document a');
		var $btn_con = $('.js-checked-contact, .js-checked-contact a');

		$btn_doc.on('click',function() {
			var $target_doc = $('input[type="radio"][value="資料請求"]');
			$target_doc.prop('checked', true);
		});

		$btn_con.on('click',function() {
			var $target_con = $('input[type="radio"][value="お問い合わせ"]');
			$target_con.prop('checked', true);
		});
	});


	// Block Editor : FAQ Accordion
	// --------------------------------------------------------------- //
	$(function () {
		$('.js-faq-link').click(function() {
			var $target = $(this).closest('.wp-faq-acc-item');
			$target.find('.wp-faq-acc-item__text').slideToggle('fast');
			$target.toggleClass('is-active');
		} );
	});


	// Block Editor : Case
	// --------------------------------------------------------------- //
	var caseSwiper = new Swiper('.js-case-swiper', {
		slidesPerView: 2,
		spaceBetween: 32,
		centeredSlides: false,
		breakpoints: {
			961: {
				slidesPerView: 1,
				spaceBetween: 32,
				centeredSlides: true,
			},
		},
		navigation: {
			nextEl: '.wp-case-button-next',
			prevEl: '.wp-case-button-prev'
		}
	});


	// Block Editor : animation
	// --------------------------------------------------------------- //
	var $animationTarget = document.querySelectorAll('.has-scroll-fade:not(.is-animation)');
	var controller = new ScrollMagic.Controller();

	var _loop = function _loop(i) {
		var scene = new ScrollMagic.Scene({
			triggerElement: $animationTarget[i],
			triggerHook: 'onEnter',
			reverse: true,
			offset: 100
		}).addTo(controller);
		scene.on('enter', function () {
			//console.log('enter');
			$animationTarget[i].classList.add('is-animation');
		});
		scene.on('leave', function () {
			$animationTarget[i].classList.remove('is-animation');
		});
		scene.on('end', function () {
			//console.log('end');
			scene.destroy(true);
		});
	};

	for (var i = 0; i < $animationTarget.length; i++) {
		_loop(i);
	}




	// only "Zelo Law Square"
	// --------------------------------------------------------------- //

	// menu
	$(function () {
		var $button = $('.js-menu-button');
		var $target = $('.js-navigation');
		var $background = $('.js-menu-bg');
		var class_name = 'is-open';
		$button.click(function (e) {
			if (!$target.hasClass(class_name)) {
				$target.addClass(class_name);
				current_scrollYsm = $window.scrollTop();
				$body.css({
					position: 'fixed',
					width: '100%',
					top: -1 * current_scrollYsm
				});
			} else {
				$target.removeClass(class_name);
				$body.attr({
					style: ''
				});
				$(window).scrollTop(current_scrollYsm);
			}
			e.preventDefault();
		});
		$background.click(function (e) {
			$target.removeClass(class_name);
			$body.attr({
				style: ''
			});
			$(window).scrollTop(current_scrollYsm);
		});
	});

	// swiper - home - main
	$(function () {
		if (!$('.js-zls-slider-main').length) {
			return false;
		}
		$('.js-zls-slider-main').each(function (index) {
			var $this = $(this);
			var $navi = $('.s-home-main-post-navi');
			var $prev = $navi.find('.js-zls-slider-main-navi-prev');
			var $next = $navi.find('.js-zls-slider-main-navi-next');
			if (device == 'sp') {
				var pv = 1;
				// if ($this.find('.swiper-slide').length <= pv) {
				// 	$this.addClass('is-slider-disabled');
				// 	return false;
				// }
				var slider = new Swiper($this, {
					loop: true,
					loopAdditionalSlides: 1,
					speed: 300,
					slidesPerView: pv,
					spaceBetween: 8,

					pagination: {
						el: '.js-zls-slider-main-navi-count',
						type: 'fraction',
					},

					navigation: {
						prevEl: $prev,
						nextEl: $next,
					},

				});
			} else {
				var pv = 1;
				// if ($this.find('.swiper-slide').length <= pv) {
				// 	$this.addClass('is-slider-disabled');
				// 	return false;
				// }
				var slider = new Swiper($this, {
					loop: true,
					loopAdditionalSlides: 1,
					speed: 300,
					slidesPerView: pv,
					spaceBetween: 16,
					centeredSlides: true,

					pagination: {
						el: '.js-zls-slider-main-navi-count',
						type: 'fraction',
					},

					navigation: {
						prevEl: $prev,
						nextEl: $next,
					},

				});
			}
		});
	});

	// swiper - home - archive
	$(function () {
		if (!$('.js-zls-slider').length) {
			return false;
		}
		$('.js-zls-slider').each(function (index) {
			var $this = $(this);
			var $prev = $this.siblings('.s-home-archive-slider-navi').find('.js-home-archive-prev');
			var $next = $this.siblings('.s-home-archive-slider-navi').find('.js-home-archive-next');

			if (device == 'sp') {
				var pv = 1;
				if ($this.find('.swiper-slide').length <= pv) {
					$this.addClass('is-slider-disabled');
					// return false;
				}
				var slider = new Swiper($this, {
					loop: false,
					speed: 300,
					slidesPerView: pv,
					spaceBetween: 16,
					freeMode: true,
					watchSlidesProgress: true,
					watchSlidesVisibility: true,
				});
			} else {
				var pv = 4;
				if ($this.find('.swiper-slide').length <= pv) {
					$this.addClass('is-slider-disabled');
					// return false;
				}

				var slider = new Swiper($this, {
					loop: false,
					speed: 300,
					slidesPerView: pv,
					spaceBetween: 32,
					watchSlidesProgress: true,
					watchSlidesVisibility: true,

					navigation: {
						prevEl: $prev,
						nextEl: $next,
					},
				});
			}
		});
	});

	// sns 追従
	$(function () {
		if (device == 'sp') {
			return false;
		}
		if (!$('.js-sticky').length) {
			return false;
		}

		var $target = $('.js-sticky .s-social-list'),
			$trigger = $('.js-sticky'),
			$container = $('.s-single-column'),
			$window = $(window),

			target_top = $target.offset().top,
			trigger_top = $trigger.offset().top,
			container_top = $container.offset().top;

			if ($('.s-single-eyecatch').length) {
				var h = 138 + 32; // ネガテォブマージン分計算
			} else {
				var h = 32;
			}

		$window.on('scroll resize', function () {
			target_top = $target.css('position') === 'static' ? trigger_top + $target.position().top : target_top;

			var $target_height = $target.outerHeight(true),
				$container_height = $container.outerHeight(),
				$window_top = $window.scrollTop();

			if ($window_top + $target_height > container_top + $container_height - h) {
				$target.removeClass('is-fixed');
			} else if ($window_top >= target_top - h) {
				$target.addClass('is-fixed');
			} else {
				$target.removeClass('is-fixed');
			}

			if ($window_top + $target_height > container_top + $container_height - h) {
				$target.addClass('is-fixed--bottom');
			} else if ($window_top >= target_top + h) {
				$target.removeClass('is-fixed--bottom');
			} else {
				$target.removeClass('is-fixed--bottom');
			}
		});
	});

	// copy link
	$('.js-copy-link').on('click', function () {
		var $text = $(this).attr('data-url');
		var clipboardText = $text;
		if (navigator.clipboard == undefined) {
			window.clipboardData.setData('Text', clipboardText);
		} else {
			navigator.clipboard.writeText(clipboardText);
		}

		$(this).addClass('is-active').delay(1500).queue(function(next) {
			$(this).removeClass('is-active');
			next();
		});
	});
});


// loading用
// --------------------------------------------------------------- //
$(window).on('load', function () {

	// init
	var $window = $(window);
	var $body = $('body');

	(function () {
		$body.addClass('is-loaded');
	}());


	// floating CTA
	// --------------------------------------------------------------- //
	// LPO - CTA
	$(function () {
		if (!$('.js-floating-cta').length) {
			return false;
		}
		var $this = $('.js-floating-cta');
		var $contents_fin = $('.p-lpo-contact').offset().top - $(window).height();

		$(window).scroll(function () {
			var $win = $(window).scrollTop();

			if ($win > 200 && $win < $contents_fin) {
				$this.addClass('is-floating--active');
			} else {
				$this.removeClass('is-floating--active');
			}

		});
	});


	// ZLS - CTA
	$(function () {
		if (!$('.js-zls-floating-cta').length) {
			return false;
		}
		var $this = $('.js-zls-floating-cta');
		var $zls_cta_fin = $('.s-cta').offset().top - $(window).height();

		$(window).scroll(function () {
			var $win = $(window).scrollTop();

			if ($win > 100 && $win < $zls_cta_fin) {
				$this.addClass('is-floating--active');
			} else {
				$this.removeClass('is-floating--active');
			}

		});
	});


	// Block Editor : Floating
	// --------------------------------------------------------------- //
	$(function () {
		if (!$('.js-wp-floating').length) {
			return false;
		}
		var $this = $('.js-wp-floating');
		var $contents_fin = $('.js-floating-end').offset().top - $(window).height();

		$(window).scroll(function () {
			var $win = $(window).scrollTop();

			if ($win > 200 && $win < $contents_fin) {
				$this.addClass('is-active');
			} else {
				$this.removeClass('is-active');
			}

		});
	});

});
